module.exports = __webpack_public_path__ + "img/05-thumbnail.68d8d949.jpg";